import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { naoPerturbeAPI } from '@/lib/api';
import { PhoneOff, X } from 'lucide-react';

// Faixa de alerta (ADMIN/BKO) quando o token da Conexão Claro é recusado
const NaoPerturbeAlerta = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [alerta, setAlerta] = useState(null);
  const [fechado, setFechado] = useState(false);
  const podeVer = user && (user.perfil === 'ADMIN' || user.perfil === 'BKO');

  useEffect(() => {
    if (!podeVer) return;
    let ativo = true;
    const carregar = async () => {
      try {
        const res = await naoPerturbeAPI.alerta();
        if (ativo) setAlerta(res.data);
      } catch { /* silencioso */ }
    };
    carregar();
    const t = setInterval(carregar, 5 * 60 * 1000);
    return () => { ativo = false; clearInterval(t); };
  }, [podeVer, location.pathname]);

  if (!podeVer || fechado || !alerta?.configurado || alerta.valido || location.pathname === '/nao-perturbe') return null;
  return (
    <div className="flex items-center gap-3 bg-red-600 text-white px-4 py-2 text-sm" data-testid="nao-perturbe-alerta">
      <PhoneOff className="w-4 h-4 shrink-0" />
      <p className="flex-1 min-w-0">
        <span className="font-semibold">Lei Não Perturbe:</span> {alerta.conector_pareado ? 'a sessão da Conexão Claro caiu — faça login no portal da Claro no navegador com o conector' : 'o token da Conexão Claro expirou — as vendas novas não estão sendo consultadas'}{alerta.pendentes ? ` (${alerta.pendentes} pendente${alerta.pendentes > 1 ? 's' : ''})` : ''}.
      </p>
      <Link to="/nao-perturbe" className="shrink-0 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1 text-xs font-semibold transition-colors" data-testid="nao-perturbe-alerta-renovar">{alerta.conector_pareado ? 'Ver status' : 'Renovar token'}</Link>
      <button onClick={() => setFechado(true)} className="shrink-0 p-1 rounded hover:bg-white/15" aria-label="Fechar" data-testid="nao-perturbe-alerta-fechar"><X className="w-4 h-4" /></button>
    </div>
  );
};

export default NaoPerturbeAlerta;
